import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { close, save } from './actions'
import { SettingsPopup } from '../SettingsPopup'
import { getFormData, getSchema, getUiSchema } from './utils'
import { ModalDescriptorForType } from '../../../store/modals/types'
import { nlpIntentSelector } from '../../../store/botNlp/selectors'
import { useSettingsPopupState } from '../hooks'

type Props = {
  modalDescriptor: ModalDescriptorForType<'intent_settings'>
}

export const IntentSettingsPopup: React.FC<Props> = memo<Props>(({ modalDescriptor }) => {
  const { modelId, intentId, openSection = 'form' } = modalDescriptor

  const dispatch = useDispatch()
  const intent = useSelector(nlpIntentSelector(modelId, intentId))

  const { initialFormData, formData, onFormDataChange } = useSettingsPopupState(
    () => getFormData(intent, openSection),
    [openSection]
  )

  return (
    <SettingsPopup
      schema={getSchema()}
      onChange={onFormDataChange}
      openSection={openSection}
      uiSchema={getUiSchema()}
      close={() => dispatch(close())}
      formData={formData}
      initialFormData={initialFormData}
      save={settings => dispatch(save(modelId, intentId, settings))}
      validationErrorsByField={{}}
    />
  )
})
